// extracted by mini-css-extract-plugin
module.exports = {"disclaimer-text":"DisclaimerText--disclaimer-text--1Vzl3","disclaimerText":"DisclaimerText--disclaimer-text--1Vzl3"};